"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DispatchWrapper = void 0;
const tslib_1 = require("tslib");
const styled_1 = tslib_1.__importDefault(require("@emotion/styled"));
const react_core_1 = require("@neo-one/react-core");
exports.DispatchWrapper = styled_1.default(react_core_1.Box) ``;

//# sourceMappingURL=DispatchWrapper.js.map
